export var auStates = [{
    'name': 'AUSTRALIAN CAPITAL TERRITORY',
    'abbreviation': 'ACT'
}, {
    'name': 'NEW SOUTH WALES',
    'abbreviation': 'NSW'
}, {
    'name': 'NORTHERN TERRITORY - AUSTRALIA',
    'abbreviation': 'NT'
}, {
    'name': 'QUEENSLAND',
    'abbreviation': 'QLD'
}, {
    'name': 'SOUTHERN AUSTRALIA',
    'abbreviation': 'SA'
}, {
    'name': 'TASMANIA',
    'abbreviation': 'TAS'
}, {
    'name': 'VICTORIA',
    'abbreviation': 'VIC'
}, {
    'name': 'WESTERN AUSTRALIA',
    'abbreviation': 'WA'
}];

export default auStates;



//////////////////
// WEBPACK FOOTER
// ./data/au.states.js
// module id = 371
// module chunks = 0